<div style="width: 270px; background-color: white;">
  <input id="inlineEditText" type="text" class="input_validation" [(ngModel)]="data"
    pInputText [maxlength]="maxlength" [class.input-error]="toolTipShow"
    (keyup)="tooltipHide()">
    <span class="material-icons done_icon" (click)="proceed()">done</span>
    <span class="material-icons close_icon" (click)="cancel()">clear</span>
  </div>

  @if (toolTipShow) {
    <div class="tooltip shadow bottom">
      <div class="arrow"></div>
      <div id="tooltiptext" class="tooltiptext">
        {{tooltipMessage}}
      </div>
    </div>
  }